// Prepend http:// if the user typed a bare host. Both the wizard's
// click-through URL field and the publisher submission detail's external
// links use this — accepts "example.com" → "http://example.com". Leaves
// any "scheme://..." input alone so we don't synthesize malformed hrefs
// like "http://ftp://example.com".
export const ensureAbsoluteUrl = (url: string): string =>
  /^[a-z][a-z0-9+.-]*:\/\//i.test(url) ? url : `http://${url}`;

export const formatMoney = (n: number | null | undefined): string =>
  (n ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Smart: drop decimals when value is a whole number, otherwise show exactly 2.
// $25 → "25", $262.5 → "262.50", $1000 → "1,000".
export const formatMoneySmart = (n: number | null | undefined): string => {
  const v = n ?? 0;
  const hasFraction = Math.round(v * 100) % 100 !== 0;
  return v.toLocaleString('en-US', {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: 2,
  });
};
